import React, { Component } from 'react';
import {Map, Marker, GoogleApiWrapper} from 'google-maps-react';
 
export class MapContainer extends Component {
  render() {
  	const style = {
	  width: '100%',
	  height: '100%'
	}
    return (
      <Map 
      	google={this.props.google}
      	zoom={14}
      	style={style}
		initialCenter={{
            lat: 53.06987112238332,
            lng: 19.436176998283365
        }}
      	>
 		
        <Marker onClick={this.onMarkerClick}
            name='Hadepol Flexo' />
      </Map>
    );
  }
}
 
export default GoogleApiWrapper({
  apiKey: 'AIzaSyAuzy0pahxDTnyhELq5H2vvK_sYW3eg0QE'
})(MapContainer)